'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import styles from './hero-layout.module.css';

export function HeroSlideSkeleton() {
  return (
    <div
      className={cn(
        'animate-pulse',
        'bg-slate-100',
        styles.slide,
        styles.skeleton,
        'h-[500px] w-full overflow-hidden rounded-2xl sm:h-[550px] md:h-[575px] lg:h-[660px] xl:h-[660px]',
      )}
    />
  );
}
